import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  // YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';

const barDefault = {
  xAxisProps: {
    dataKey: 'name',
    textAnchor: 'end',
    verticalAnchor: 'end',
    scaleToFit: false,
    interval: 0,
    fontSize: '10px',
    // scale: 'auto',
  },
  yAxisProps: {
    fontSize: '10px',
  },
};

function SocialAmeliorationComponent({
  chartData,
}) {
  return (
    <ResponsiveContainer width="100%" height={400} className="mw-100">
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="colorFillSenior" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#5272AA" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#5272AA" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorFillPwd" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#A3B3F9" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A3B3F9" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorFillStudent" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8EEED7" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8EEED7" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorFillSingleParent" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#87A1D1" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#87A1D1" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid height={1} y={0} />
        <XAxis {...barDefault.xAxisProps} dataKey="name" />
        <Tooltip />
        {/* social_amelioration_beneficiary */}
        <Area
          type="monotone"
          dataKey="SENIOR"
          stackId="1"
          stroke="#5272AA"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorFillSenior)"
        />
        <Area
          type="monotone"
          dataKey="PWD"
          stackId="2"
          stroke="#A3B3F9"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorFillPwd)"
        />
        <Area
          type="monotone"
          dataKey="STUDENT"
          stackId="3"
          stroke="#8EEED7"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorFillStudent)"
        />
        <Area
          type="monotone"
          dataKey="SOLO PARENT"
          stackId="4"
          stroke="#87A1D1"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorFillSingleParent)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

SocialAmeliorationComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default SocialAmeliorationComponent;
